import { api, getConfigApi } from './../../services/api'

export const getMapData = async (): Promise<unknown> => {
    return await api.get('portal/map')
}

export const searchInitiatives = async (filtro?: any): Promise<unknown> => {
    return await api.post('portal/search', filtro)
}